import { useState, useEffect } from "react";

import React from "react";
import { Button, Card } from "react-bootstrap";
import ProductsTable from "./ProductsTable";
import ProductsModal from "./ProductsModal";

import axios from "axios";
import Loader from "../../components/Loader";
import { getHostName } from "../../helpers/utils";

const Banners = () => {
  const hostname = getHostName();

  const [dataList, setDataList] = useState([]);

  const [loader, setLoader] = React.useState(false);

  const [payload, setPayload] = React.useState({});

  //  modal
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    getDataList();
  }, []);

  const getDataList = () => {
    axios
      .get(`${hostname}/api/products/get-all-products`)
      .then((res) => {
        console.log(res.data.data);
        setDataList(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const createEntry = () => {
    let obj = {};
    obj.loadType = "Add Product";

    setPayload({ ...obj });
    handleShow();
  };

  const viewEntry = (obj) => {
    obj.loadType = "View Product";

    setPayload({ ...obj });
    handleShow();
  };

  const updateEntry = (obj) => {
    obj.loadType = "Update Product";

    setPayload({ ...obj });
    handleShow();
  };

  const deleteEntry = (obj) => {
    obj.loadType = "Delete Product";

    setPayload({ ...obj });
    handleShow();
  };

  if (loader) {
    return <Loader />;
  } else {
    return (
      <div>
        <Card>
          <Card.Body className="overflow-hidden" style={{ minHeight: "90vh" }}>
            <div
              style={{ display: "flex", justifyContent: "space-between" }}
              className="mb-3"
            >
              <h4>Products</h4>

              <Button variant="primary" size="sm" onClick={createEntry}>
                + Add
              </Button>
            </div>

            <br />
            <ProductsTable
              list={dataList}
              viewEntry={viewEntry}
              updateEntry={updateEntry}
              deleteEntry={deleteEntry}
            />
            <br />

            <ProductsModal
              show={show}
              handleClose={handleClose}
              payload={payload}
              setPayload={setPayload}
              getAllData={getDataList}
              hostname={hostname}
            />
          </Card.Body>
        </Card>
      </div>
    );
  }
};

export default Banners;
